import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { ListSurveyFormsQuery } from "./API";
import { API, graphqlOperation } from "aws-amplify";
import { JExcelElement } from "jexcel";
import jsonorder from "json-order";
import XLSX from "xlsx";
import { Button, makeStyles } from "@material-ui/core";
import { SaveAlt } from "@material-ui/icons";
import { parseISO, format } from "date-fns";
const jspreadsheet = require("jspreadsheet-ce");

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

interface Input {
  id: string;
  content: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

interface Form {
  name: string;
  description: string;
  model: string;
}

interface Component {
  type: string;
  name: string;
  title: string;
  content: string;
}

const SurveyResults = () => {
  const classes = useStyles();
  const { resultKey } = useParams<{ resultKey: string }>();
  const sheetRef = useRef<HTMLDivElement>(null);
  const [form, setForm] = useState<Form>();
  const [spreadSheet, setSpreadSheet] = useState<JExcelElement>();
  //const [inputs, setInputs] = useState<Input[]>([]);
  // const [spreadsheet, setSpreadsheet] = useState(null);

  useEffect(() => {
    if (!sheetRef.current?.hasChildNodes()) {
      fetchResults();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchResults = async () => {
    const query = `
      query Query($resultKey: String!) {
        listSurveyForms(
          filter: {resultKey: {eq: $resultKey}}
        ) {
          items {
            id
            name
            description
            model
            results(limit: 1000) {
              items {
                id
                content
                createdBy
                createdAt
                updatedAt
              }
            }
          }
        }
      }
    `;
    const result = (await API.graphql(
      graphqlOperation(query, { resultKey })
    )) as GraphQLResult<ListSurveyFormsQuery>;
    // console.log(result);
    const items = result.data?.listSurveyForms?.items;
    if (items && items.length > 0 && items[0]) {
      const form = items[0] as Form;
      setForm(form);
      const columns = createColumns(form);
      const inputs = (form as any).results?.items as Input[];
      setInputs(columns, inputs);
      console.log(inputs);
    }
  };

  const createColumns = (
    form: Form
  ): { name: string; title: string; width: number }[] => {
    const columns: { name: string; title: string; width: number }[] = (
      JSON.parse(form.model).elements as {
      name: string;
      }[]
    ).map((el) => {
      return { name: el.name, title: el.name, width: 300 };
    });
    return [
      { name: "createdBy", title: "社員番号", width: 100 },
      ...columns,
      { name: "createdAt", title: "作成日", width: 200 },
      { name: "updatedAt", title: "更新日", width: 200 },
    ];
  };

  const setInputs = (
    columns: { name: string, title: string; width: number }[],
    inputs: Input[]
  ) => {
    if (inputs.length > 0) {
      // create header & jss instance
      const jss: JExcelElement = jspreadsheet(sheetRef.current, {
        columns,
        editable: false,
      });

      // create rows
      inputs.forEach((input, rowIndex) => {
        const data = {
          createdBy: input.createdBy,
          ...JSON.parse(input.content),
          createdAt: format(parseISO(input.createdAt), "yyyy/MM/dd HH:mm:ss"),
          updatedAt: format(parseISO(input.updatedAt), "yyyy/MM/dd HH:mm:ss"),
        };
        // console.log(data);
        jss.insertRow();
        columns.forEach((column, columnIndex) => {
          const value = data[column.name];
          const text =
            typeof value === "string" ? value : JSON.stringify(value);
          jss.setValueFromCoords(columnIndex, rowIndex, text, true);
        });
      });
      jss.refresh();
      setSpreadSheet(jss);
    }
  };

  const handleDownload = () => {
    const data = [
      spreadSheet?.getHeaders([]),
      ...(spreadSheet?.getData() as any[][]),
    ];
    console.log(data);
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "results");
    XLSX.writeFile(wb, "results.xlsx");
  };

  return (
    <div>
      <h2>Results</h2>
      <div>{form?.name}</div>
      <div style={{whiteSpace: 'pre-line'}}>{form?.description}</div>
      <div>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          startIcon={<SaveAlt />}
          onClick={handleDownload}
        >
          Download(XLSX)
        </Button>
      </div>
      <div id="spreadsheet" ref={sheetRef}></div>
    </div>
  );
};

export default SurveyResults;
